import lf from 'lovefield'

export function simu_analyses (schemaBuilder) {
  schemaBuilder.createTable('simu_analyses')
      //.addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_etudes_id', lf.Type.INTEGER)
      .addColumn('passages', lf.Type.INTEGER)
      .addColumn('erreursCoherence', lf.Type.INTEGER)
      .addColumn('erreursUsage', lf.Type.INTEGER)
      .addColumn('erreursInutile', lf.Type.INTEGER)
      .addColumn('erreursRemblai', lf.Type.INTEGER)
      .addColumn('erreursDate', lf.Type.INTEGER)
      .addColumn('erreursDuree', lf.Type.INTEGER)
      .addColumn('erreursInstallation', lf.Type.INTEGER)
      .addColumn('erreursCoherenceTab', lf.Type.STRING)
      .addColumn('erreursUsageTab', lf.Type.STRING)
      .addColumn('erreursInutileTab', lf.Type.STRING)
      .addColumn('erreursRemblaiTab', lf.Type.STRING)
      .addColumn('erreursDateTab', lf.Type.STRING)
      .addColumn('erreursDureeTab', lf.Type.STRING)
      .addColumn('erreursInstallationTab', lf.Type.STRING)
      .addColumn('date_validation', lf.Type.DATE_TIME)
      .addColumn('date_etude', lf.Type.DATE_TIME)
      .addColumn('passagesInstallation', lf.Type.INTEGER)
      .addColumn('bonusQ', lf.Type.INTEGER)
      .addColumn('tabBonusQualiteMouvements', lf.Type.STRING)
      .addColumn('installationQ', lf.Type.INTEGER)
      .addColumn('installationQMax', lf.Type.INTEGER)
      .addColumn('tabBonusInstallationQ', lf.Type.STRING)
      .addColumn('installationS', lf.Type.INTEGER)
      .addColumn('installationSMax', lf.Type.INTEGER)
      .addColumn('tabBonusInstallationS', lf.Type.STRING)
      .addColumn('installationE', lf.Type.INTEGER)
      .addColumn('installationEMax', lf.Type.INTEGER)
      .addColumn('tabBonusInstallationE', lf.Type.STRING)
      .addColumn('installationInhib', lf.Type.INTEGER)
/* 2019 évolutions Terrassor */
      .addColumn('etape_epure', lf.Type.INTEGER) // 0 données génériques, 1 cubature, 2 mouvement, 4 simulation
      .addColumn('etape_epure_atteinte', lf.Type.INTEGER)
      .addColumn('mode_utilisation', lf.Type.INTEGER) // mode Epure (1), Examen (2) et Simulateur (0)
/*    
      .addColumn('passagesEpure', lf.Type.INTEGER)
      .addColumn('erreursEpure', lf.Type.INTEGER)
      .addColumn('erreursEpureTab', lf.Type.STRING)
*/
/* */
      //.addPrimaryKey(['id'], true)
      .addPrimaryKey(['simu_etudes_id'], false)
      .addNullable(['date_validation', 'date_etude', 'installationQMax', 'installationSMax', 'installationEMax']); // BC 2018/07 - les valeurs supprimées de cette liste / cf. ci-dessous / ne doivent pas être à "null"
/*      .addNullable(['passages', 'erreursCoherence', 'erreursUsage', 'erreursInutile', 'erreursRemblai', 'erreursDate', 'date_validation', 'date_etude', 'passagesInstallation', 'bonusQ', 'installationQ', 'installationS', 'installationE', 'installationQMax', 'installationSMax', 'installationEMax', 'installationInhib']);*/
      // .addIndex('simuEtudes_id', ['simuEtudes_id']);

}

/*
CREATE TABLE IF NOT EXISTS `simu-mouvements` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-etudes_id` int(11) NOT NULL,
  `exo-mouvements_id` int(11) NOT NULL,
  `debut` date NOT NULL,
  `fin` date NOT NULL,
  PRIMARY KEY (`id`),
  KEY `simu-etudes_id` (`simu-etudes_id`,`exo-mouvements_id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuAnalyses.schema.js